import { useEffect, useRef } from 'react';
import './Timeline.css';

const events = [
    {
        year: '1137',
        title: 'Born in Tikrit',
        desc: 'Salah ad-Din Yusuf was born to a Kurdish family in Tikrit, modern-day Iraq. His father Najm ad-Din Ayyub was a military governor.',
        side: 'left',
        icon: '🌙',
    },
    {
        year: '1163',
        title: 'Enters Egyptian Politics',
        desc: 'Appointed as the right-hand of his uncle Shirkuh in the Fatimid court, beginning his rise to power in Egypt.',
        side: 'right',
        icon: '⚜️',
    },
    {
        year: '1169',
        title: 'Vizier of Egypt',
        desc: 'Saladin became vizier of the Fatimid Caliphate of Egypt, effectively controlling the country and rapidly consolidating power.',
        side: 'left',
        icon: '👑',
    },
    {
        year: '1174',
        title: 'Sultan of Egypt & Syria',
        desc: 'After the death of Nur ad-Din, Saladin proclaimed himself Sultan, uniting Egypt and Syria under the Ayyubid dynasty.',
        side: 'right',
        icon: '🏛️',
    },
    {
        year: '1187',
        title: 'Battle of Hattin',
        desc: 'On July 4th, Saladin decisively defeated the Crusader states at the Battle of Hattin, capturing King Guy of Jerusalem.',
        side: 'left',
        icon: '⚔️',
    },
    {
        year: '1187',
        title: 'Liberation of Jerusalem',
        desc: 'On October 2nd, Saladin entered Jerusalem peacefully. He showed remarkable mercy, allowing Christians safe passage — a stark contrast to the Crusader conquest of 1099.',
        side: 'right',
        icon: '🕌',
        highlight: true,
    },
    {
        year: '1192',
        title: 'Treaty of Jaffa',
        desc: 'Signed a peace treaty with Richard I of England (Richard the Lionheart), ending the Third Crusade. The treaty allowed Christian pilgrims access to Jerusalem.',
        side: 'left',
        icon: '📜',
    },
    {
        year: '1193',
        title: 'Returned to God\'s Mercy',
        desc: 'Saladin passed away in Damascus on March 4th, aged 55. He had given so much of his treasury to the poor that his estate had barely enough to cover funeral costs.',
        side: 'right',
        icon: '☽',
    },
];

const Timeline = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.timeline__item')
                            .forEach((el, i) => {
                                setTimeout(() => el.classList.add('revealed'), i * 150);
                            });
                        entry.target.querySelectorAll('.reveal')
                            .forEach((el) => el.classList.add('revealed'));
                    }
                });
            },
            { threshold: 0.05 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="timeline" className="timeline-section" ref={sectionRef}>
            <div className="section-wrapper">
                <div className="timeline-section__header reveal" style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 70px' }}>
                    <span className="section-tag">Key Milestones</span>
                    <h2 className="section-title">
                        A Life of <span className="gold-text">Conquest</span> &amp; Honor
                    </h2>
                    <div className="divider" style={{ margin: '20px auto 0' }}></div>
                </div>

                <div className="timeline">
                    <div className="timeline__line"></div>
                    {events.map((event, index) => (
                        <div
                            key={index}
                            className={`timeline__item timeline__item--${event.side} ${event.highlight ? 'timeline__item--highlight' : ''}`}
                        >
                            <div className="timeline__content">
                                <div className="timeline__icon">{event.icon}</div>
                                <div className="timeline__year">{event.year}</div>
                                <h3 className="timeline__title">{event.title}</h3>
                                <p className="timeline__desc">{event.desc}</p>
                            </div>
                            <div className="timeline__dot">
                                <div className="timeline__dot-inner"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Timeline;
